module.exports = __webpack_public_path__ + "static/media/swap.db8ec6a4.svg";